import axios from "axios";

// Function to handle API request
const getApiResponse = async ({ method, url, token, body }) => {
  let request = {
    method,
    url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Attach body data if available
  request = body ? { ...request, data: { ...body } } : request;

  // Attach token to headers if available
  request = token
    ? {
        ...request,
        headers: { ...request.headers, Authorization: `Bearer ${token}` },
      }
    : request;

  return axios({
    ...request,
  });
};

// Helper function to handle data response
export const getResponseData = async (Payload) => {
  try {
    const getdata = await getApiResponse(Payload);
    return getdata.data;
  } catch (e) {
    return e?.status;
  }
};

// Function to create axios base query with dynamic base URL
export const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "https://jobmanagement-497524552274.us-central1.run.app/api" }) =>
  async (payload) => {
    const { url } = payload;
    const fullUrl = `${baseUrl}${url}`; // Concatenate the base URL with the endpoint
    const payloads = { ...payload, url: fullUrl };

    try {
      const result = await getApiResponse(payloads);
      if (result?.data && result?.data?.error) {
        const error = {
          status: 200,
          data: result?.data?.error,
        };
        throw error;
      } else {
        return { data: result.data };
      }
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: axiosError?.status,
          data: axiosError.data?.errorMessage,
        },
      };
    }
  };


